import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { UserCompany } from '@/types';
    import EditUserCompany from './EditUserCompany.vue';

    interface Props {
        userCompany: UserCompany;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UserCompanyTableActions',
  props: {
    userCompany: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.userCompany }, {
    default: _withCtx(() => [
      _createVNode(EditUserCompany, { "user-company": _ctx.userCompany }, null, 8, ["user-company"])
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})